export default __webpack_public_path__ + "static/media/no_missions.e008f84b.png";